import type { MouseEvent } from 'react';
import { OrderStatus } from 'types/OrderStatus.type';

import type { OrderListResultData } from '@frontend/api';
import {
  Flex,
  HStack,
  IconButtonGroup,
  Text,
} from '@frontend/legacy-components';

import { InternalNotesPopover } from 'components/internalNotesPopover';
import OrderStatusBadge from 'components/lib2/OrderStatusBadge';

import { useActiveTab } from 'modules/orders/listPage/hooks';

export type OrderNumberCellContentProps = {
  rowData: OrderListResultData;
};

export const OrderNumberCellContent = ({
  rowData,
}: OrderNumberCellContentProps) => {
  const activeTab = useActiveTab();
  const shouldShowStatus = activeTab === 'all';

  const orderNumberAndActions = (
    <HStack justifyContent={'space-between'} flex={'1'} w="100%">
      <Text as="span" fontWeight="heavy">
        {rowData.number}
      </Text>
      <IconButtonGroup
        display={'flex'}
        gap={0.75}
        onClick={(event: MouseEvent) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        {rowData.privateNotes && <InternalNotesPopover order={rowData} />}
      </IconButtonGroup>
    </HStack>
  );

  return shouldShowStatus ? (
    <Flex direction="column" align="flex-start" w="100%">
      {orderNumberAndActions}
      <OrderStatusBadge size="sm" orderStatus={rowData.status as OrderStatus} />
    </Flex>
  ) : (
    orderNumberAndActions
  );
};
